export default "__VITE_ASSET__a588e0da__"